import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import AdminGate from "@/components/admin/AdminGate";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminGate><Admin /></AdminGate>} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0D1322",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#F8FAFC",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
